import {
	useAdminFetchBondNumbers,
	useAdminSetNextBondNumberBlock,
} from "@portal/api/bond-number/admin";
import { CenteredSpinner } from "../ui/CenteredSpinner";
import { ErrorDisplay } from "../ui/ErrorDisplay";
import { MutationErrorFlag } from "../ui/MutationErrorFlag";
import { BondNumberCard } from "./BondNumberCard";

export const ManageBondNumbers = () => {
	const { bondNumbers, bondNumbersLoading, bondNumbersError, invalidateBondNumbers } =
		useAdminFetchBondNumbers();
	const { setNextBlock, setNextBlockLoading, setNextBlockError, dismissSetNextBlockError } =
		useAdminSetNextBondNumberBlock();

	return (
		<>
			<div data-testid="bond-numbers-container" className="flex flex-col gap-[20px]">
				{bondNumbersLoading && (
					<div className="border border-bc-default rounded-lg p-8">
						<CenteredSpinner testId="bond-numbers-loading" />
					</div>
				)}
				{bondNumbersError && (
					<ErrorDisplay
						error={bondNumbersError}
						componentToDisplay={
							<div
								data-testid="bond-numbers-error"
								className="flex w-full p-4 text-sm justify-center items-center border border-bc-default rounded-lg"
							>
								<span className="text-secondary">Unable to load bond numbers.</span>
								<a
									data-testid="retry-link"
									className="cursor-pointer m-1 text-link hover:text-link-hover"
									onClick={() => invalidateBondNumbers()}
								>
									Retry
								</a>
							</div>
						}
					/>
				)}
				{!bondNumbersLoading &&
					!bondNumbersError &&
					(bondNumbers.length === 0 ? (
						<div
							data-testid="bond-numbers-empty"
							className="flex p-8 w-full justify-center items-center border border-bc-default rounded-lg text-secondary text-sm"
						>
							No bond number counters found.
						</div>
					) : (
						bondNumbers.map((counter) => (
							<BondNumberCard
								key={counter.counterId}
								counter={counter}
								submitting={setNextBlockLoading}
								onSubmit={(block) => setNextBlock({ carrierName: counter.carrierName, block })}
							/>
						))
					))}
			</div>
			<MutationErrorFlag
				errorHeading="Set Next Block Error"
				mutationError={setNextBlockError}
				dismissError={dismissSetNextBlockError}
			/>
		</>
	);
};
